import { useSelector as useReduxSelector, type TypedUseSelectorHook } from 'react-redux'

import type { AppStore } from 'core/redux/store'

const useSelector: TypedUseSelectorHook<AppStore> = useReduxSelector

export default useSelector
